"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Fri Jul 20 2018
 */

var immutable_1 = require("immutable");

var CodebookItem_1 = require("../../core/model/codebook/CodebookItem");
/**
 * Every item in release has assigned the price code. There are some price codes that have no usage for this application,
 * but are important somehow for external system.
 *
 * @author RV
 * @author VRu
 */


var PriceCode =
/*#__PURE__*/
function (_CodebookItem_1$Codeb) {
  _inherits(PriceCode, _CodebookItem_1$Codeb);

  /**
   * @param id
   * @param title the title of the format
   * @param externalId the external id
   */
  function PriceCode(id, title, externalId) {
    var _this;

    _classCallCheck(this, PriceCode);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PriceCode).call(this, id, title, null, immutable_1.List(), externalId));
    _this.id = id;
    _this.title = title;
    _this.externalId = externalId;
    return _this;
  }

  return PriceCode;
}(CodebookItem_1.CodebookItem);

exports.PriceCode = PriceCode;
/** Name of code book for generic code book API. */

PriceCode.CODEBOOK_NAME = 'pricelists.codes';